// extracted by mini-css-extract-plugin
export var scrollArea = "_rh-0";